'use strict';

function valueIsNotInfinite(m) {
  return m !== -Infinity && m !== Infinity;
}

module.exports = valueIsNotInfinite;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/internal/valueIsNotInfinite.js
// module id = 419
// module chunks = 1